<template>
  <div class="container-fluid mt-4 mb-4">
    <div class="hero">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="hero-content">
              <h1 class="display-4 font-weight-bold  text-white">Alert History</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Boxes-->

    <div class="boxes-hero">
      <div class="container">
        <div class="row equal">
          <div class="col-md-12 my-2">
            <div class="box shadow-lg bg-white rounded">

              <div class="box-header bg-light-blue rounded-top p-3">
                <div class="row">
                  <div class="col">
                    Alert History
                  </div>
                </div>
              </div>
              <div style="padding: 10px">
                    <b-table
                        primary-key="id"
                        emptyText="There are no alerts to show"
                        striped
                        :id="`alert-table`"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :items="alert_history"
                        :fields="fields.alert_history"
                    >

                      <template v-slot:cell(duration)="item">
                        {{ item.item | display_duration }}
                      </template>

                      <template v-slot:cell(value)="item">
                        {{ item.item | compute_alert_value }}
                      </template>

                      <template v-slot:cell(threshold)="item">
                        {{ item.item | display_threshold }}
                      </template>

                    </b-table>

                    <b-row v-if="alert_history.length > 20" class="my-5">
                      <b-col>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            align="center"
                        >
                        </b-pagination>
                      </b-col>
                    </b-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { get_alert_history } from '../../networking/alerts'
import moment from 'moment'
import axios from 'axios'

const capitalize = value => value ? String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase() : ''

const alert_history_fields = [
  { key: 'imei', label: 'Serial' },
  { key: 'alertName', label: 'Alert Name' },
  { key: 'status', formatter: v => capitalize(v), class:"alert-status" },
  {
    key: 'startDateTime',
    label: 'Start Time',
    formatter: value => value ? moment((new Date(value))).format('YYYY-MM-DD hh:mm:ss a') : null,
    class:"d-none d-md-table-cell alert-triggered",
    sortable: true
  },
  {
    key: 'endDateTime',
    label: 'End Time',
    formatter: value => value ? moment((new Date(value))).format('YYYY-MM-DD hh:mm:ss a') : null,
    class:"d-none d-md-table-cell alert-triggered",
    sortable: true
  },
  { key: 'duration', class:"d-none d-md-table-cell" },
  { key: 'value', class:'d-none d-md-table-cell' },
  { key: 'threshold', label: 'Threshold' },
]

const compute_alert_duration = ({ status, startDateTime, endDateTime }) => status === 'OPEN'
    ?   moment.duration(moment(startDateTime).diff(moment(new Date))).humanize()
    :   moment.duration(moment(startDateTime).diff(moment(endDateTime))).humanize()

export default {
  props:{
    userData:{
      type: Object,
      required: true
    }
  },
  components: {  },
  data(){
    return {
      fields:{
        alert_history: alert_history_fields,
      },

      alert_history: [],
      tabIndex: 0,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
    }
  },

  async created(){
    const { value: { data: alert_history = [] }} = await get_alert_history({ accountId: this.userData.accountId, sort_asc: false })
    this.alert_history = alert_history
  },

  methods: {
  },

  filters: {
    capitalize: value => value ? String(value).charAt(0).toUpperCase() + String(value).slice(1) : '',
    display_duration: item => compute_alert_duration(item),
    display_threshold: ({ alertType, eventData = '{}', threshold, magZ }) => ({
      'LEAK': `${threshold} hrs`,
      'BATTERY': `${threshold} mV`,
      'HIGHFLOW': `${threshold} GPM`,
      'LOWFLOW': `${threshold} GPM`,
      'LOWPRESSURE': `${Math.round((magZ/100 + Number(threshold))*10)/10} psi`,
      'LOWLEVEL': `${threshold} in`,
      'HIGHLEVEL': `${threshold} in`,
      'DEVICE_BATTERY': `${threshold}%`,
      'WATER_NUMBER': JSON.parse(eventData).previousWaterNumberAverage,
      'COMMUNICATION': `${threshold} hrs`
    })[alertType],

    compute_alert_value: ({
                            alertType, gpm, waterLevelInches, psi, batteryVoltage, threshold, magY, eventData = '{}', ...alert
                          }) => ({
      'LEAK': `${threshold} hrs`,
      'BATTERY': `${batteryVoltage } mV`,
      'LOWFLOW': `${gpm} GPM`,
      'HIGHFLOW': `${gpm} GPM`,
      'LOWPRESSURE': `${magY/100} psi`,
      'LOWLEVEL': `${waterLevelInches} in`,
      'HIGHLEVEL': `${waterLevelInches} in`,
      'DEVICE_BATTERY': `${batteryVoltage }mV`,
      'WATER_NUMBER': JSON.parse(eventData).waterNumber,
      // 'COMMUNICATION': moment((new Date(JSON.parse(eventData).lastReportDateTime))).format('YYYY-MM-DD hh:mm:ss a')
    })[alertType]
  },

  watch:{
    alert_history(items){ this.totalRows = items.length }
  }
}

</script>

<style>

.btn-open {
  color: #fff !important;
  border: none !important;
  background-color: green !important;
}

.btn-close {
  color: #fff !important;
  border: none !important;
  background-color: crimson !important;
}

.nav-link .nav-link.active {
  text-color: black;
  margin:5px;
}

.nav-link {
  margin-right:3px;
}

.nav-tabs .nav-link.active {
  background-color: #296a9b;
  color: #fff !important;
}

.nav-tabs .nav-link {
  background-color: #eeeeee;
}

</style>

